module.exports = __webpack_public_path__ + "b81afaadbc5403c6e618aeda3db3124c.png";